import Service from './service';
import { getServicesUrl, getWmsServiceUrl } from '../../setup';
import { APIVersion, ServiceTypes } from '../../types/main';
import Security from './security';

class Common extends Service {
    static async getGeneralSettings() {
        await Security.generateApplicationTokensIfNeeded();

        return Service.getRequest(`${getServicesUrl()}/settings?group=General`);
    }

    static getNewsSettings() {
        return new Promise(((resolve) => {
            Common.getGeneralSettings().then((response: any) => {
                resolve(
                    response?.data?.find((item) => item.Key === 'NewsAssetTypeId'),
                );
            });
        }));
    }

    static getAssetClasses(language) {
        return Service.getRequest(`${getServicesUrl()}/assetclasses/${language}`, { isSecure: true });
    }

    static async getSectors(language) {
        await Security.generateApplicationTokensIfNeeded();

        return Service.getRequest(`${getWmsServiceUrl()}/sectors/${language}`, { isSecure: true, cache: false, type: ServiceTypes.WITH_MEMBER_TOKEN });
    }

    static async getSecurityTypes(language) {
        await Security.generateApplicationTokensIfNeeded();

        return Service.getRequest(`${getWmsServiceUrl()}/securitytypes/${language}`, { isSecure: true, cache: false, type: ServiceTypes.WITH_MEMBER_TOKEN });
    }

    static async getCountries(language) {
        await Security.generateApplicationTokensIfNeeded();

        return Service.getRequest(`${getServicesUrl()}/countries/${language}`, { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN });
    }

    static async getLanguages(language) {
        await Security.generateApplicationTokensIfNeeded();

        return Service.getRequest(`${getServicesUrl()}/languages/${language}`, { isSecure: true, type: ServiceTypes.WITH_MEMBER_TOKEN });
    }

    static getRiskCategories(language) {
        return Service.getRequest(`${getServicesUrl()}/riskcategories?language=${language}`, { isSecure: true });
    }

    static getRiskCategoriesByProduct(productId, language) {
        return Service.getRequest(`${getServicesUrl(APIVersion.V11)}/products/${productId}/riskcategories?language=${language}`, { isSecure: true });
    }
}

export default Common;
